import React from 'react';

interface OperationSettlementStatusBarIconProps {
  testId?: string;
  className?: string;
  text: string;
}

export const OperationSettlementStatusBarIcon: React.FC<
  OperationSettlementStatusBarIconProps
> = ({ text, testId, className }) => {
  return (
    <div
      data-testid={testId}
      className={`noto-11-semibold flex h-5 w-5 items-center justify-center rounded-[5px] bg-light-6 text-light-1 ${className}`}
    >
      {text}
    </div>
  );
};
